export default "__VITE_ASSET__DND9brs6__"